// extracted by mini-css-extract-plugin
export default {"container":"LpWordCloud_container__lhjJA","smallContainer":"LpWordCloud_smallContainer__AxGlf LpWordCloud_container__lhjJA","noResponsesText":"LpWordCloud_noResponsesText__EZauf"};